import { Link } from 'libs/router/Link';
import { useRouter } from 'libs/router/useRouter';

import { useInt } from 'hooks/useInt';

import { Icon } from 'ui/atoms/Icon/Icon';

import { isRouteAvailable } from 'features/layout/routeLocaleAvailability';

import styles from './HeaderMenu.module.scss';

export const SolutionsSidebar = () => {
  const { query } = useRouter();
  const { t } = useInt();
  const lang = (query.lang as string) || 'en';

  // The Regis promo links to the CMS 'regis' page; hide it where that page has no localized version.
  if (!isRouteAvailable('regis', lang)) {
    return null;
  }

  return (
    <div className={styles.platformColumn}>
      <div className={styles.featuredBlock}>
        <Icon type="payg-40" className={styles.featuredWatermark} />

        <div className={styles.featuredContent}>
          <div className={styles.featuredHeader}>
            <span className={styles.featuredIcon}>
              <Icon type="payg-40" />
            </span>
            <p className={styles.featuredTitle}>Regis AI</p>
          </div>

          <p className={styles.featuredDescription}>
            {t(
              'The AI agent for live company registry data. Ask in plain language, get cited answers from official sources.',
            )}
          </p>

          <Link route="regis" className={styles.featuredButton}>
            <span>{t('Try Regis free')}</span>
            <Icon type="arrow-14" />
          </Link>

          <span className={styles.featuredFoot}>{t('Powered by 400+ official registries in 200+ countries')}</span>
        </div>
      </div>
    </div>
  );
};
